export async function setup() {
  const videoData = [];

  videoData.XL = [];
  videoData.XL.English = [];
  videoData.XL.English.stage2 = require("../assets/video/XL/English/stage2.mp4");
  videoData.XL.English.stage2Subs = require("../assets/video/XL/English/stage2.vtt");
  videoData.XL.English.stage3 = require("../assets/video/XL/English/stage3.mp4");
  videoData.XL.English.stage3Subs = require("../assets/video/XL/English/stage3.vtt");
  videoData.XL.English.stage5 = require("../assets/video/XL/English/stage5.mp4");
  videoData.XL.English.stage5Subs = require("../assets/video/XL/English/stage5.vtt");
  videoData.XL.English.stage7 = require("../assets/video/XL/English/stage7.mp4");
  videoData.XL.English.stage7Subs = require("../assets/video/XL/English/stage7.vtt");
  videoData.XL.English.stage9 = require("../assets/video/XL/English/stage9.mp4");
  videoData.XL.English.stage9Subs = require("../assets/video/XL/English/stage9.vtt");
  videoData.XL.English.stage11 = require("../assets/video/XL/English/stage11.mp4");
  videoData.XL.English.stage11Subs = require("../assets/video/XL/English/stage11.vtt");
  videoData.XL.English.stage12 = require("../assets/video/XL/English/stage12.mp4");
  videoData.XL.English.stage12Subs = require("../assets/video/XL/English/stage12.vtt");

  videoData.ncs = [];
  videoData.ncs.English = [];
  videoData.ncs.English.stage2 = require("../assets/video/ncs/English/stage2.mp4");
  videoData.ncs.English.stage2Subs = require("../assets/video/ncs/English/stage2.vtt");
  videoData.ncs.English.stage3 = require("../assets/video/ncs/English/stage3.mp4");
  videoData.ncs.English.stage3Subs = require("../assets/video/ncs/English/stage3.vtt");
  videoData.ncs.English.stage5 = require("../assets/video/ncs/English/stage5.mp4");
  videoData.ncs.English.stage5Subs = require("../assets/video/ncs/English/stage5.vtt");
  videoData.ncs.English.stage7 = require("../assets/video/ncs/English/stage7.mp4");
  videoData.ncs.English.stage7Subs = require("../assets/video/ncs/English/stage7.vtt");
  videoData.ncs.English.stage9 = require("../assets/video/ncs/English/stage9.mp4");
  videoData.ncs.English.stage9Subs = require("../assets/video/ncs/English/stage9.vtt");
  videoData.ncs.English.stage11 = require("../assets/video/ncs/English/stage11.mp4");
  videoData.ncs.English.stage11Subs = require("../assets/video/ncs/English/stage11.vtt");
  videoData.ncs.English.stage12 = require("../assets/video/ncs/English/stage12.mp4");
  videoData.ncs.English.stage12Subs = require("../assets/video/ncs/English/stage12.vtt");

  videoData.itg = [];
  videoData.itg.English = [];
  videoData.itg.English.stage2 = require("../assets/video/itg/English/stage2.mp4");
  videoData.itg.English.stage2Subs = require("../assets/video/itg/English/stage2.vtt");
  videoData.itg.English.stage3 = require("../assets/video/itg/English/stage3.mp4");
  videoData.itg.English.stage3Subs = require("../assets/video/itg/English/stage3.vtt");
  videoData.itg.English.stage5 = require("../assets/video/itg/English/stage5.mp4");
  videoData.itg.English.stage5Subs = require("../assets/video/itg/English/stage5.vtt");
  videoData.itg.English.stage7 = require("../assets/video/itg/English/stage7.mp4");
  videoData.itg.English.stage7Subs = require("../assets/video/itg/English/stage7.vtt");
  videoData.itg.English.stage9 = require("../assets/video/itg/English/stage9.mp4");
  videoData.itg.English.stage9Subs = require("../assets/video/itg/English/stage9.vtt");
  videoData.itg.English.stage11 = require("../assets/video/itg/English/stage11.mp4");
  videoData.itg.English.stage11Subs = require("../assets/video/itg/English/stage11.vtt");
  videoData.itg.English.stage12 = require("../assets/video/itg/English/stage12.mp4");
  videoData.itg.English.stage12Subs = require("../assets/video/itg/English/stage12.vtt");
  videoData.itg.English.itgsizzle = require("../assets/video/itg/English/itgsizzle.mp4");
  videoData.itg.English.itgsizzleSubs = require("../assets/video/itg/English/itgsizzle.vtt");


  videoData.XLonline = [];
  videoData.XLonline.English = [];
  videoData.XLonline.English.stage2 = require("../assets/video/XLonline/English/stage2.mp4");
  videoData.XLonline.English.stage2Subs = require("../assets/video/XLonline/English/stage2.vtt");
  videoData.XLonline.English.stage3 = require("../assets/video/XLonline/English/stage3.mp4");
  videoData.XLonline.English.stage3Subs = require("../assets/video/XLonline/English/stage3.vtt");
  videoData.XLonline.English.stage5 = require("../assets/video/XLonline/English/stage5.mp4");
  videoData.XLonline.English.stage5Subs = require("../assets/video/XLonline/English/stage5.vtt");
  videoData.XLonline.English.stage7 = require("../assets/video/XLonline/English/stage7.mp4");
  videoData.XLonline.English.stage7Subs = require("../assets/video/XLonline/English/stage7.vtt");
  videoData.XLonline.English.stage72 = require("../assets/video/XLonline/English/stage72.mp4");
  videoData.XLonline.English.stage72Subs = require("../assets/video/XLonline/English/stage72.vtt");
  videoData.XLonline.English.stage9 = require("../assets/video/XLonline/English/stage9.mp4");
  videoData.XLonline.English.stage9Subs = require("../assets/video/XLonline/English/stage9.vtt");
  videoData.XLonline.English.stage11 = require("../assets/video/XLonline/English/stage11.mp4");
  videoData.XLonline.English.stage11Subs = require("../assets/video/XLonline/English/stage11.vtt");
  videoData.XLonline.English.stage12 = require("../assets/video/XLonline/English/stage12.mp4");
  videoData.XLonline.English.stage12Subs = require("../assets/video/XLonline/English/stage12.vtt");

  videoData.ITGOnline = [];
  videoData.ITGOnline.English = [];
  videoData.ITGOnline.English.stage2 = require("../assets/video/ITGOnline/English/stage2.mp4");
  videoData.ITGOnline.English.stage2Subs = require("../assets/video/ITGOnline/English/stage2.vtt");
  videoData.ITGOnline.English.stage3 = require("../assets/video/ITGOnline/English/stage3.mp4");
  videoData.ITGOnline.English.stage3Subs = require("../assets/video/ITGOnline/English/stage3.vtt");
  videoData.ITGOnline.English.stage5 = require("../assets/video/ITGOnline/English/stage5.mp4");
  videoData.ITGOnline.English.stage5Subs = require("../assets/video/ITGOnline/English/stage5.vtt");
  videoData.ITGOnline.English.stage7 = require("../assets/video/ITGOnline/English/stage7.mp4");
  videoData.ITGOnline.English.stage7Subs = require("../assets/video/ITGOnline/English/stage7.vtt");
  // videoData.ITGOnline.English.stage72 = require("../assets/video/ITGOnline/English/stage72.mp4");
  // videoData.ITGOnline.English.stage72Subs = require("../assets/video/ITGOnline/English/stage72.vtt");
  videoData.ITGOnline.English.stage9 = require("../assets/video/ITGOnline/English/stage9.mp4");
  videoData.ITGOnline.English.stage9Subs = require("../assets/video/ITGOnline/English/stage9.vtt");
  videoData.ITGOnline.English.stage11 = require("../assets/video/ITGOnline/English/stage11.mp4");
  videoData.ITGOnline.English.stage11Subs = require("../assets/video/ITGOnline/English/stage11.vtt");
  // videoData.ITGOnline.English.stage12 = require("../assets/video/ITGOnline/English/stage12.mp4");
  // videoData.ITGOnline.English.stage12Subs = require("../assets/video/ITGOnline/English/stage12.vtt");

  return videoData;


}
